import { render } from "./LabelCard.vue?vue&type=template&id=51c30334"
import script from "./LabelCard.vue?vue&type=script&lang=js"
export * from "./LabelCard.vue?vue&type=script&lang=js"

import "./LabelCard.vue?vue&type=style&index=0&id=51c30334&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Cards/LabelCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51c30334"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51c30334', __exports__)) {
    api.reload('51c30334', __exports__)
  }
  
  module.hot.accept("./LabelCard.vue?vue&type=template&id=51c30334", () => {
    api.rerender('51c30334', render)
  })

}


export default __exports__